import React, { useState } from 'react';
import styled from 'styled-components';

const QAContainer = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

const QuestionForm = styled.form`
  margin-bottom: 30px;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 100px;
  padding: 12px;
  border: 0.5px solid #e0e0e0;
  border-radius: 4px;
  margin-bottom: 10px;
  resize: vertical;
  font-size: 14px;
`;

const SubmitButton = styled.button`
  padding: 8px 16px;
  background-color: #1890ff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  
  &:hover {
    background-color: #40a9ff;
  }
`;

const QuestionList = styled.div`
  margin-top: 20px;
`;

const QuestionItem = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
`;

const QuestionHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f0f0f0;
  margin-right: 12px;
  object-fit: cover;
  
  /* 添加默认背景，当图片加载失败时显示 */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f0f0f0 url('默认头像URL') no-repeat center/cover;
  }
`;

const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const Username = styled.span`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 4px;
`;

const Time = styled.span`
  font-size: 14px;
  color: #999;
`;

const QuestionContent = styled.div`
  font-size: 14px;
  color: #333;
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  margin-bottom: 8px;
`;

const ReplySection = styled.div`
  margin-top: 8px;
  background-color: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
`;

// 添加讲师信息
const instructor = {
  avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/user/2020/11-28/0137062c3032405892.jpg',  // 替换为实际的讲师头像URL
  name: 'Frank老师'
};

// 修改模拟数据，添加讲师信息
const mockQuestions = [
  {
    id: 1,
    user: '学员小王',
    time: '2025-03-30',
    content: '请问课程中的实战项目源码可以提供吗？',
    reply: '课程源码会在课程结束后提供下载链接，请关注课程公告。',
    replyTime: '2025-03-31',
    avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/default/2024/04-15/1318593e2b02319515.jpg',
    instructorAvatar: instructor.avatar,
    instructorName: instructor.name
  },
  {
    id: 2,
    user: '学员小李',
    time: '2025-03-29',
    content: '老师，课程的先修要求是什么？',
    reply: '建议具备基础的JavaScript知识和React基础概念。',
    replyTime: '2025-03-30',
    avatar: 'https://sce8a9b0c4d5sr-sb-qn.qiqiuyun.net/files/default/2023/11-13/1512491f09f7588745.jpg',
    instructorAvatar: instructor.avatar,
    instructorName: instructor.name
  }
];

const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).replace(/\//g, '/');
};

const CourseQA = () => {
  const [questions, setQuestions] = useState(mockQuestions);
  const [newQuestion, setNewQuestion] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newQuestion.trim()) return;

    const newQuestionObj = {
      id: questions.length + 1,
      user: '用户名',
      time: new Date().toISOString().split('T')[0],
      content: newQuestion,
      reply: '',
      replyTime: ''
    };

    setQuestions([newQuestionObj, ...questions]);
    setNewQuestion('');
  };

  return (
    <QAContainer>
      <QuestionForm onSubmit={handleSubmit}>
        <TextArea
          placeholder="请输入您的问题..."
          value={newQuestion}
          onChange={(e) => setNewQuestion(e.target.value)}
        />
        <SubmitButton type="submit">提交问题</SubmitButton>
      </QuestionForm>

      <QuestionList>
        {questions.map((question) => (
          <QuestionItem key={question.id}>
            <QuestionHeader>
              <Avatar src={question.avatar}/>
              <UserInfo>
                <Username>{question.user}</Username>
                <Time>{formatDate(question.time)}</Time>
              </UserInfo>
            </QuestionHeader>
            <QuestionContent>{question.content}</QuestionContent>
            {question.reply && (
              <ReplySection>
                <QuestionHeader>
                  <Avatar src={question.instructorAvatar} />
                  <UserInfo>
                    <Username>{question.instructorName}</Username>
                    <Time>{formatDate(question.replyTime)}</Time>
                  </UserInfo>
                </QuestionHeader>
                <QuestionContent>{question.reply}</QuestionContent>
              </ReplySection>
            )}
          </QuestionItem>
        ))}
      </QuestionList>
    </QAContainer>
  );
};

export default CourseQA;